import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const Store = ({ storeName }) => (
  <PropertyRow propertyLabel={{ label: _TL_('Store') }}>
    <Text>{storeName}</Text>
  </PropertyRow>
);

Store.propTypes = {
  storeName: PropTypes.string,
};

Store.defaultProps = {
  storeName: null,
};
